import { render, staticRenderFns } from "./import-detail.vue?vue&type=template&id=8327492c"
import script from "./import-detail.vue?vue&type=script&lang=js"
export * from "./import-detail.vue?vue&type=script&lang=js"
import style0 from "./import-detail.vue?vue&type=style&index=0&id=8327492c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports